export default function SysRow({
  data
}) {
  return (
    <div className="flex justify-center">
      <span className="bg-cf5 text-helper px-pix-10 py-pix-2 rounded-lg">{data.message}</span>
    </div>
  )
}
